import React, { Component } from 'react'

export default class Setting extends Component {
    //the list of users who can see you
    //deny the access of users
    //
    render() {
        return (
            <div >
                
                {/* the page contains 
                1. the list of user who can see my records
                2. update profile
                3. share your id for one some users */}
            </div>
        )
    }
}
